export default __webpack_public_path__ + "076f4289c5954fd9515e63575e08ff19.svg";